/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ResumeTriggerInstanceSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ResumeTriggerInstanceRequest = {
  /**
   * The trigger instance ID.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ResumeTriggerInstanceSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ResumeTriggerInstanceSecurity$outboundSchema: z.ZodMiniType<
  ResumeTriggerInstanceSecurity$Outbound,
  ResumeTriggerInstanceSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function resumeTriggerInstanceSecurityToJSON(
  resumeTriggerInstanceSecurity: ResumeTriggerInstanceSecurity,
): string {
  return JSON.stringify(
    ResumeTriggerInstanceSecurity$outboundSchema.parse(
      resumeTriggerInstanceSecurity,
    ),
  );
}

/** @internal */
export type ResumeTriggerInstanceRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ResumeTriggerInstanceRequest$outboundSchema: z.ZodMiniType<
  ResumeTriggerInstanceRequest$Outbound,
  ResumeTriggerInstanceRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function resumeTriggerInstanceRequestToJSON(
  resumeTriggerInstanceRequest: ResumeTriggerInstanceRequest,
): string {
  return JSON.stringify(
    ResumeTriggerInstanceRequest$outboundSchema.parse(
      resumeTriggerInstanceRequest,
    ),
  );
}
